module.exports = __webpack_public_path__ + "static/media/ic-search-grey.bed1354a.svg";